import React, { useEffect, useState } from "react";
import CustomTable from "../../../components/table/table";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import { admin_internship_applications_list, superadmin_internship_applications_list } from "../admin.api";
import moment from "moment";

export default function InternshipApplications(props) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchApplications();
  }, [page, perPage]);

  const handlePerPageChange = (e) => {
    setPerPage(parseInt(e.target.value));
    setPage(1);
  };

  const fetchApplications = () => {
    setIsLoading(true);
    const adminType = localStorage.getItem("adminType");
    const apiCall =
      adminType === 2
        ? superadmin_internship_applications_list(page, perPage)
        : admin_internship_applications_list(page, perPage);
    
    apiCall
      .then((res) => {
        if (res?.success) {
          setData(res.data || []);
          setTotalPages(res.pagination?.last_page || 1);
        } else {
          setSnackMessage("Failed to load internship applications");
          setIsSnackError(true);
          setSnackOpen(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching applications:", error);
        setSnackMessage("Error loading internship applications");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsLoading(false);
      });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 1:
        return { label: "Approved", color: "success" };
      case 2:
        return { label: "Reverted", color: "warning" };
      case 3:
        return { label: "Rejected", color: "danger" };
      default:
        return { label: "Pending", color: "secondary" };
    }
  };

  const columns = [
    { title: "ID", field: "id" },
    { title: "Full Name", field: "full_name" },
    { title: "Email", field: "email" },
    { title: "Phone", field: "phone_no" },
    {
      title: "Course Status",
      field: "course_completion_status",
      render: (rowData) => (
        <span className="text-capitalize">
          {rowData.course_completion_status}
        </span>
      ),
    },
    {
      title: "Date Applied",
      field: "created_at",
      render: (rowData) => moment(rowData.created_at).format("DD-MM-YYYY")
    },
    {
      title: "Status",
      field: "status",
      render: (rowData) => (
        <span className={`badge bg-${getStatusBadge(rowData.status).color}`}>
          {getStatusBadge(rowData.status).label}
        </span>
      ),
    },
    {
      title: "Action",
      render: (rowData) => (
        <button
          className="btn btn-primary btn-sm"
          onClick={() => props.history.push(`/admin-internship-applications/${rowData.id}`)}
        >
          View
        </button>
      ),
    },
  ];

  const renderPagination = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          className={`btn btn-sm ${page === i ? 'btn-primary' : 'btn-outline-primary'} mx-1`}
          onClick={() => setPage(i)}
        >
          {i}
        </button>
      );
    }
    return pages;
  };



  return (
    <div className="container-fluid mt-4">
      <Loader open={isLoading} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />

      <div className="card shadow-sm">
        <div className="card-header bg-white py-3">
          <h5 className="mb-0"><b>Internship Applications</b></h5>
        </div>
        <div className="card-body">
          <CustomTable
            columns={columns}
            data={data}
            paging={false}
            options={{
              search: true,
            }}
          />

          <div className="d-flex justify-content-center mt-4">
            <div className="flex-grow-1"></div>
            <div className="btn-group">
              <button
                className="btn btn-sm btn-outline-primary"
                disabled={page === 1}
                onClick={() => setPage(p => p - 1)}
              >
                Prev
              </button>
              {renderPagination()}
              <button
                className="btn btn-sm btn-outline-primary"
                disabled={page === totalPages}
                onClick={() => setPage(p => p + 1)}
              >
                Next
              </button>
            </div>
            <div className="flex-grow-1 d-flex justify-content-end">
              <select
                className="form-control form-control-sm w-auto ml-2"
                value={perPage}
                onChange={handlePerPageChange}
                style={{ fontSize: "8px", height: "31px" }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
